import { Selector } from "@ngxs/store";

import { LogState, LogStateModel } from "./log.state";
import { LogModel } from "../../core/models";
import { IRequestsNestedState } from "../interfaces/requests.interface";

export class LogGetterState {
  @Selector([LogState])
  static getLogState(state: LogStateModel): LogStateModel {
    return state;
  }

  @Selector([LogState])
  static getLogs(state: LogStateModel): LogModel[] {
    return state.ids.map((id) => state.entities[id]);
  }

  @Selector([LogState])
  static getLiveLogs(state: LogStateModel): LogModel[] {
    return state.liveLogsIds.map((id) => state.entities[id]);
  }

  @Selector([LogState])
  static getLastLogs(state: LogStateModel): LogModel[] {
    return state.lastLogsIds.map((id) => state.entities[id]);
  }

  static groupLogs(logs: LogModel[]): LogModel[][] {
    const uniqueVehicleIds: number[] = [
      ...new Set(logs.map((log) => log.logVehicleId)),
    ];
    return uniqueVehicleIds.map((id) => {
      return logs
        .filter((log) => log.logVehicleId === id)
        .sort((a, b) => {
          return new Date(a.logLocalDateTime) > new Date(b.logLocalDateTime)
            ? -1
            : 1;
        });
    });
  }

  @Selector([LogGetterState.getLiveLogs])
  static getLiveLogsGroupedByVehicle(logs: LogModel[]): LogModel[][] {
    return this.groupLogs(logs);
  }

  @Selector([
    LogGetterState.getLiveLogsGroupedByVehicle,
    LogGetterState.getColors,
  ])
  static getColoredLiveLogsGroupedByVehicle(
    groupedLogs: LogModel[][],
    colors: { [key: number]: string }
  ): { groupedLogs: LogModel[][]; colors: { [key: number]: string } } {
    return {
      groupedLogs,
      colors,
    };
  }

  @Selector([LogState])
  static getInactiveVehiclesLogs(state: LogStateModel): LogModel[] {
    return state.inactiveVehiclesLogsIds.map((id) => state.entities[id]);
  }

  @Selector([LogState])
  static getColors(state: LogStateModel): { [key: number]: string } {
    return state.colors;
  }

  @Selector([LogGetterState.getLiveLogs, LogGetterState.getColors])
  static getColoredLiveLogs(
    logs,
    colors
  ): { logs: LogModel[]; colors: { [key: number]: string } } {
    return {
      logs,
      colors,
    };
  }

  @Selector([LogState])
  static getReport(state: LogStateModel) {
    return state.report;
  }

  @Selector([LogState])
  static getGenerateReportRequestState(
    state: LogStateModel
  ): IRequestsNestedState {
    return state.requests.generateReport;
  }

  @Selector([LogState])
  static getLastLogsGetRequestState(
    state: LogStateModel
  ): IRequestsNestedState {
    return state.requests.getLastLogs;
  }
}
